import { forwardRef } from 'react'

import { Grid } from '@material-ui/core'
import { createAddress } from 'Components/Validation/Settings/Various/PLA'
import { Field, Formik } from 'formik'
import { TextField } from 'formik-material-ui'

const Form = forwardRef((props, ref) => {
  const { onSubmit } = props
  return (
    <>
      <Formik
        initialValues={{
          calle: '',
        }}
        validationSchema={createAddress}
        onSubmit={onSubmit}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ submitForm, isSubmitting }) => (
          <Grid container spacing={2}>
            <Grid item sm={12} xs={12}>
              <div style={{ height: '70px' }}>
                <Field
                  component={TextField}
                  fullWidth
                  label="Calle"
                  name="calle"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    maxLength: 50,
                  }}
                />
              </div>
            </Grid>

            <button
              type="submit"
              onClick={submitForm}
              disabled={isSubmitting}
              ref={ref}
              style={{ display: 'none' }}
            />
          </Grid>
        )}
      </Formik>
    </>
  )
})
export default Form
